import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";
import { Cookies } from "react-cookie";

export const uploadCsv = createAsyncThunk(
  "whitelist/uploadCsv",
  async ({ id, csvFile }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", csvFile);
      const cookies = new Cookies();
      const token = cookies.get("token");

      const response = await AxiosInstance.post(
        `${API_KEY}/api/whitelist/upload-csv/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const initialState = {
  isLoading: false,
  uploadCsvData: null,
  isError: false,
  errorMessage: "",
};

const uploadCsvSlice = createSlice({
  name: "uploadCsv",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadCsv.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(uploadCsv.fulfilled, (state, action) => {
        state.isLoading = false;
        state.uploadCsvData = action.payload;
      })
      .addCase(uploadCsv.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload || "Failed to upload CSV file.";
      });
  },
});

export default uploadCsvSlice.reducer;
